module.exports = __webpack_public_path__ + "img/sample-report-bcg.b54b33e.webp";